module.exports = __webpack_public_path__ + "static/future-work-home-3-5ebfda4f4701ef6aaca1a808343bce4a.jpg";